import { Vue } from 'vue-class-component';
export default class GridItem extends Vue {}